import { render, staticRenderFns } from "./WorkCentersTable.vue?vue&type=template&id=19f99455&scoped=true&"
import script from "./WorkCentersTable.vue?vue&type=script&lang=js&"
export * from "./WorkCentersTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkCentersTable.vue?vue&type=style&index=0&id=19f99455&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f99455",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressLinear,VTooltip})
